import { createTRPCReact, type inferReactQueryProcedureOptions } from '@trpc/react-query';
import type { inferRouterInputs, inferRouterOutputs } from '@trpc/server';
import type { TRPCClientErrorLike } from '@trpc/client';

import type { AppRouter } from '~/backend/config/trpc';

type AppRouterErrorData = NonNullable<TRPCClientErrorLike<AppRouter>['data']> & {
  apiErrorCode?: string;
  apiErrorData?: unknown;
};

export type ReactQueryOptions = inferReactQueryProcedureOptions<AppRouter>;
export type RouterInputs = inferRouterInputs<AppRouter>;
export type RouterOutputs = inferRouterOutputs<AppRouter>;
export type AppRouterError = Omit<TRPCClientErrorLike<AppRouter>, 'data'> & {
  readonly data: AppRouterErrorData | null | undefined;
};

export const trpc = createTRPCReact<AppRouter>();
